<template>
	<div
		v-if="label || iconToken"
		:class="{
			'checkbox--disabled' : disabled,
			'checkbox--selected' : checked
		}"
		class="checkbox"
		data-cy="checkbox"
		role="checkbox"
		:aria-checked="ariaChecked"
		:tabindex="tabIndex"
		@click="toggleCheckbox"
		@keyup.space="toggleCheckbox"
	>
		<input
			v-model="checked"
			:disabled="disabled"
			type="checkbox"
			class="checkbox__input"
			@change="$emit('changed', value)"
		>

		<span
			:class="{
				'is-animating' : animating
			}"
			class="checkbox__check"
		>
			<helio-icon
				color="white"
				token="check"
				weight="light"
			/>
		</span>

		<label
			class="checkbox__label"
		>
			<helio-icon
				v-if="iconToken"
				:weight="iconWeight"
				:token="iconToken"
			/>
			<span v-html="label" />
		</label>
	</div>
</template>

<script>
import Icon from '../icon/Icon.vue';

export default {
	name: 'Checkbox',

	components: {
		'helio-icon': Icon,
	},

	props: {
		disabled: {
			type: Boolean,
			required: false,
			default: false,
			description: 'Sets whether the Checkbox will be disabled for the user',
		},

		iconToken: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the icon that will appear next to the Checkbox label',
		},

		iconWeight: {
			type: String,
			required: false,
			default: 'regular',
			validator: value => [
				'bold',
				'brand',
				'light',
				'regular',
			].indexOf(value) !== -1,
			description: 'Sets the weight of the icon',
		},

		initialChecked: {
			type: Boolean,
			required: false,
			default: false,
			description: 'Sets whether the Checkbox will already be checked when the component is mounted',
		},

		label: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the Checkbox\'s label text',
		},
	},

	data() {
		return {
			checked: false,
			ariaChecked: false,
			tabIndex: '0',
			animating: false,
		};
	},

	watch: {
		initialChecked(checked) {
			if (this.checked !== checked) {
				this.checked = checked;
				this.ariaChecked = checked;
			}
		},
	},

	created() {
		this.checked = this.initialChecked;
		this.ariaChecked = this.initialChecked;
		if (this.disabled) {
			this.tabIndex = '-1';
		}
	},

	methods: {
		toggleCheckbox() {
			if (!this.disabled) {
				this.checked = !this.checked;
				this.ariaChecked = this.checked;
				this.$emit('changed', this.checked);
				this.animate();
			}
		},

		animate() {
			this.animating = true;
			setTimeout(() => {
				this.animating = false;
			}, 200);
		},
	},
};
</script>

<style lang="scss" src="./checkbox.scss" />
